import React, { Component } from 'react';
import CrearRecepciones from './CrearRecepciones';
import CardForm from '../../../../Utils/Cards/CardForm';
import './CrearRecepciones.css';

export default class CrearRecepcionesClass extends Component {
    state = {
        pesoManual: true,
    }

    componentWillMount() {
    }

    componentDidMount() {
        // Sirve para saber si el peso bruto de ingreso se ingresa manualmente o no.
        // Se tomó este código del formulario de recepciones individuales.
        const me = this.props.me;
        if (me) {
            if (me.acopio) {
                if (me.peso_ingreso_manual_acopio === false) {
                    this.setState({ pesoManual: false });
                }
            } else {
                if (me.peso_ingreso_manual === false) {
                    this.setState({ pesoManual: false });
                }
            }
        }
    }

    componentWillUnmount() {
    }

    /**
     * Función para redirigir a la vista de detalle de contenedores.
     * @param {number} viaje_id - ID del viaje.
     * @returns {void}
     */
    VerDetalleContenedores = (viaje_id) => {
        this.props.history.push(`/ingreso/ver/contenedores/${viaje_id}`);
    };

    render() {
        return (
            <div className="mb-4 col-12">
                <CardForm
                    icon="recepciones_activo"
                    titulo="RECEPCIÓN"
                    subtitulo="Nuevo"
                    col="12">
                    <CrearRecepciones
                        VerDetalleContenedores={this.VerDetalleContenedores}
                        pesoManual={this.state.pesoManual}
                    />
                </CardForm>
            </div>
        )
    }
}
